import React, {useState, useEffect} from "react";
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {useModal} from "./ModalContext";
import img1 from "../assets/home/funghi.jpg";
import Logo from "./Logo/Logo";
import Spinner from "./Spinner/Spinner";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {faArrowLeftLong} from '@fortawesome/free-solid-svg-icons';
import TicketComponent from "./Card/Ticket/TicketComponent";
import AreaComponent from "./Card/Area/AreaComponent";
import TicketInfoComponent from "./Card/Ticket/TicketInfoComponent";
import TicketProcessBuy from "./Typeform/TicketProcessBuy";

function Search() {
    const {isOpen, closeModal} = useModal();
    const [step, setStep] = useState("category");
    const [listStep, setListStep] = useState([{step: "category", name: "Categoria"}]);

    const [filters, setFilters] = useState({id_category: "", region: "", id_area: ""})
    const [tickets, setTickets] = useState([])
    const [ticketInfo, setTicketInfo] = useState(null)
    const [search, setSearch] = useState("");


    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [showAll, setShowAll] = useState(false);


    useEffect(() => {
        if (typeof filters.id_ticket === "undefined")
            return;
        fetch(global.baseUrl + "app/ticket/area/info", {
            method: 'POST',
            credentials: 'include',
            body: global.getFormData(
                {id: filters.id_ticket}
            )
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Errore nella richiesta");
                }
                return response.json();
            })
            .then((data) => {
                setTicketInfo(data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }, [filters]);


    useEffect(() => {
        if (typeof filters.id_area === "undefined" || filters.id_area === "")
            return;
        setLoading(true);

        fetch("https://api.geoticket.it/app/v2/ticket/area/list", {
            method: 'POST',
            credentials: 'include',
            body: global.getFormData(
                {id: filters.id_area}
            )
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Errore nella richiesta");
                }
                return response.json();
            })
            .then((data) => {
                setTickets(data.list);
                setLoading(false);
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });
    }, [filters]);

    useEffect(() => {
        console.log("filters");
        console.log(filters);
        setLoading(true);

        fetch("https://api.geoticket.it/app/search/filters", {
            method: 'POST',
            credentials: 'include',
            body: global.getFormData(
                filters
            )
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Errore nella richiesta");
                }
                return response.json();
            })
            .then((data) => {
                setData(data);
                setLoading(false);
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });
    }, [filters]);

    function goStep(stepObj) {
        let diff = Object.keys(listStep).length - listStep.indexOf(stepObj) - 1;
        for (let i = 1; i <= diff; i++) {
            prevStep();
        }
    }

    function nextStep(value) {
        switch (step) {
            case "category":
                setFilters({id_category: value});
                setStep("region");
                listStep.push({step: "region", name: "Regione"});
                break;
            case "region":
                setFilters({region: value});
                setStep("area");
                listStep.push({step: "area", name: "Area"});
                break;
            case "area":
                setFilters({id_area: value});
                setStep("tickets");
                listStep.push({step: "tickets", name: "Lista Ticket"});
                break;
            case "tickets":
                setFilters({id_ticket: value});
                setStep("ticket");
                listStep.push({step: "ticket", name: "Ticket"});
                break;
        }
        setListStep(listStep);
    }


    function prevStep() {
        switch (step) {
            case "category":
                setStep("category");
                break;
            case "region":
                setStep("category");
                setFilters({region: ""});
                setListStep(listStep.slice(0, listStep.length - 1));
                break;
            case "area":
                setStep("region");
                setFilters({id_area: ""});
                setListStep(listStep.slice(0, listStep.length - 1));
                break;
            case "tickets":
                setStep("area");
                setTickets([]);
                setListStep(listStep.slice(0, listStep.length - 1));
                break;

            case "tickets":
                setStep("tickets");
                setTicketInfo(null);
                setListStep(listStep.slice(0, listStep.length - 1));
                break;
        }
    }

    if (!isOpen)
        return null;
    let title = "";
    let content = [];
    let search_box;
    let back_btn;
    if (step !== "category")
        back_btn =
            <Button variant={"success"} onClick={() => prevStep()} style={{marginRight: 6}}><FontAwesomeIcon
                icon={faArrowLeftLong}/></Button>


    if (loading) {
        content = <Spinner size={"l"}/>;
    } else {
        switch (step) {
            case "category":
                title = "1. Scegli la categoria del ticket";
                search_box = <Col xs={12} md={12}>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Cerca la categoria</Form.Label>
                            <Form.Control type="text" placeholder="Nome della categoria"
                                          onChange={e => setSearch(e.target.value)}/>
                        </Form.Group>
                    </Form>
                </Col>
                let categories = [];
                if (search !== "") {
                    categories = data.categories.filter(item => item.name.toLowerCase().includes(search.toLowerCase()));
                } else {
                    categories = data.categories.slice(0, showAll ? data.categories.length : 4);
                }
                if (Object.keys(categories).length === 0) {
                    content.push(
                        <div className="container">
                            <div className="row">
                                {search_box}
                                <Alert variant={"warning"}>
                                    Nessuna categoria trovata
                                </Alert>
                            </div>
                        </div>);
                } else
                    content.push(
                        <div className="container">
                            <div className="row">
                                {search_box}
                                {categories.map((category) => (
                                    <Col xs={12} sm={6} md={3}>
                                        <div
                                            onClick={() => {
                                                nextStep(category.id);
                                            }}
                                            key={category.id}
                                            className={"card-container " + (filters.id_category === category.id ? "card-container-active" : "")}
                                            style={{backgroundImage: `url(${"https://api.geoticket.it/" + category.image})`}}
                                        >
                                            <span>{category.name}</span>
                                        </div>
                                    </Col>
                                ))}
                            </div>
                        </div>
                    );

                // Aggiungi il pulsante "Mostra altre" se ci sono più di 5 categorie
                if (data.categories.length > 4) {
                    content.push(
                        <div style={{marginTop: 16}}>
                            <Button variant="outline-info"
                                    onClick={() => setShowAll(!showAll)}>{showAll ? "Mostra meno categorie" : "Mostra altre categorie"}</Button>
                        </div>
                    );
                }
                break;
            case "region":
                title = "2. Scegli la regione del ticket";
                search_box = <Col xs={12} md={12}>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Cerca la regione</Form.Label>
                            <Form.Control type="text" placeholder="Nome della regione"
                                          onChange={e => setSearch(e.target.value)}/>
                        </Form.Group>
                    </Form>
                </Col>
                let list_regions = data.regions.flatMap(item => item.list);

                let regions = [];
                if (search !== "") {
                    regions = list_regions.filter(item => item.toLowerCase().includes(search.toLowerCase()));
                } else {
                    regions = list_regions.slice(0, showAll ? data.length : 4);
                }
                if (Object.keys(regions).length === 0) {
                    content.push(
                        <div className="container">
                            <div className="row">
                                {search_box}
                                <Alert variant={"warning"}>
                                    Nessuna regione trovata
                                </Alert>
                            </div>
                        </div>);
                } else
                    content.push(
                        <div className="container">
                            <div className="row">
                                {search_box}
                                {regions.map((region) => (
                                    <Col xs={12} sm={6} md={3}>
                                        <div
                                            onClick={() => {
                                                nextStep(region);
                                            }}
                                            key={region}
                                            className={"card-container " + (filters.region === region ? "card-container-active" : "")}>
                                            <span>{region}</span>
                                        </div>
                                    </Col>
                                ))}
                            </div>
                        </div>
                    );

                // Aggiungi il pulsante "Mostra altre" se ci sono più di 5 categorie
                if (list_regions.length > 4) {
                    content.push(
                        <div style={{marginTop: 16}}>
                            <Button variant="outline-info"
                                    onClick={() => setShowAll(!showAll)}>{showAll ? "Mostra meno regioni" : "Mostra altre regioni"}</Button>
                        </div>
                    );
                }
                break;
            case "area":
                title = "3. Scegli l'area del ticket";
                search_box = <Col xs={12} md={12}>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Cerca l'area</Form.Label>
                            <Form.Control type="text" placeholder="Nome dell'area"
                                          onChange={e => setSearch(e.target.value)}/>
                        </Form.Group>
                    </Form>
                </Col>
                let areas = [];
                if (search !== "") {
                    areas = data.list_areas.filter(item => item.name.toLowerCase().includes(search.toLowerCase()));
                } else {
                    areas = data.list_areas.slice(0, showAll ? data.list_areas.length : 4);
                }
                if (Object.keys(areas).length === 0) {
                    content.push(
                        <div className="container">
                            <div className="row">
                                {search_box}
                                <Alert variant={"warning"}>
                                    Nessuna area trovata
                                </Alert>
                            </div>
                        </div>);
                } else
                    content.push(
                        <div className="container">
                            <div className="row">
                                {search_box}
                                {areas.map((area) => (
                                    <Col xs={12} sm={6} md={3}>
                                        <div
                                            onClick={() => {
                                                nextStep(area.id);
                                            }}
                                            key={"area" + area.id}
                                            className={"card-container " + (filters.id_area === area.id ? "card-container-active" : "")}
                                            style={{backgroundImage: `url(${"https://api.geoticket.it/" + encodeURI(area.image)})`}}
                                        >
                                            <span>{area.name}</span>
                                        </div>
                                    </Col>
                                ))}
                            </div>
                        </div>
                    );

                // Aggiungi il pulsante "Mostra altre" se ci sono più di 5 categorie
                if (data.list_areas.length > 4) {
                    content.push(
                        <div style={{marginTop: 16}}>
                            <Button variant="outline-info"
                                    onClick={() => setShowAll(!showAll)}>{showAll ? "Mostra meno aree" : "Mostra altre aree"}</Button>
                        </div>
                    );
                }
                break;
            case "tickets":
                title = "4. Scegli il ticket dell'area";
                let tickets_ = tickets.slice(0, showAll ? tickets.length : 6);

                let area = data.list_areas.find(item => item.id === filters.id_area);
                if (area !== null)
                    content.push(<Row><AreaComponent area={area}/></Row>)

                if (Object.keys(tickets_).length === 0) {
                    content.push(
                        <div className="container">
                            <div className="row">
                                {search_box}
                                <Alert variant={"warning"}>
                                    Nessun ticket presente
                                </Alert>
                            </div>
                        </div>);
                } else
                    content.push(
                        <div className="container">
                            <div className="row">
                                {tickets_.map((ticket) => (
                                    <Col xs={12} sm={6} md={4}>
                                        <TicketComponent ticket={ticket} key={ticket.id}
                                                         onClick={() => nextStep(ticket.id)}/>
                                    </Col>
                                ))}
                            </div>
                        </div>
                    );

                // Aggiungi il pulsante "Mostra altre" se ci sono più di 5 categorie
                if (tickets.length > 4) {
                    content.push(
                        <div style={{marginTop: 16}}>
                            <Button variant="outline-info"
                                    onClick={() => setShowAll(!showAll)}>{showAll ? "Mostra meno ticket" : "Mostra altri ticket"}</Button>
                        </div>
                    );
                }
                break;
            case "ticket":
                title = "5. Acquisto ticket";
                if (ticketInfo === null) {
                    content.push(
                        <div className="container">
                            <div className="row">
                                <Alert variant={"warning"}>
                                    Nessun ticket selezionato
                                </Alert>
                            </div>
                        </div>);
                } else
                    content.push(<Row><TicketInfoComponent ticket={ticketInfo.ticket}/><TicketProcessBuy
                        ticket={ticketInfo.ticket}/></Row>);
                break;
        }
    }

    function renderBreadcrum() {
        let list = [];
        for (let item of listStep) {
            if (listStep.indexOf(item) === Object.keys(listStep).length - 1)
                list.push(<li className="breadcrumb-item active" aria-current="page">{item.name}</li>);
            else
                list.push(<li className="breadcrumb-item"><a href="#" onClick={() => goStep(item)}>{item.name}</a>
                </li>);
        }

        return <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                {list}
            </ol>
        </nav>
    }

    return (
        <div className="fullscreen-modal">
            <div style={{
                position: "relative",
                top: 0,
                right: 0,
                left: 0,
                zIndex: 1000,
                padding: 16,
                backgroundColor: "#eee",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "100%"
            }}>
                <div className="container" style={{display: "flex", flexDirection: "row"}}>
                    <div>
                        {back_btn}
                    </div>
                    <div style={{flex: 1}}>
                        <h3 style={{flex: 1, marginBottom: 0}}>{title}</h3>
                        {renderBreadcrum()}
                    </div>
                    <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
                </div>
            </div>
            <div className="modal-content search">
                {content}
            </div>
        </div>
    );
}

export default Search;